<template>
  <div class="recharge">
    <div class="form-horizontal">
      <recharge-form :user="user" :fee="fee" :mode="mode"></recharge-form>
      <div class="form-group">
        <div class="col-sm-10 col-sm-offset-2">
          <button class="btn btn-primary" @click="submit">确认充值</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RechargeForm from '@/components/forms/Recharge'
import * as TYPES from '../store/types'

export default {
  components: {
    RechargeForm
  },
  data() {
    return {
      mode: 'edit'
    }
  },
  computed: {
    user() {
      return this.$store.state.users.view
    },
    fee() {
      return this.$store.state.users.recharge.fee
    }
  },
  methods: {
    submit() {
      this.$confirm({
        size: 'md',
        title: '会员充值',
        content: `你将会给会员【${this.user.profile.name}】充值【${this.fee.fromCash + this.fee.fromWechat + this.fee.fromAlipay}】元，确认继续吗？`
      })
      .then(() => {
        this.doSubmit()
      })
      .catch(() => {
        this.$notify('充值已取消!')
      })
    },
    doSubmit() {
      this.$store
        .dispatch(TYPES.DO_RECHARGE, {
          userID: this.user.id,
          fee: this.fee
        })
        .then(res => {
          if (res.data.ok) {
            this.$router.push('/vip/' + this.user.profile.phone)
          } else {
            this.$notify({
              type: 'danger',
              title: '操作失败',
              content: res.data.msg
            })
          }
        })
        .catch(res => {
          this.$notify({
            type: 'danger',
            title: '操作失败',
            content: res.data.msg
          })
        })
    }
  },
  created() {
    let phone = this.$route.params.phone
    if (phone) {
      this.$store.dispatch(TYPES.DO_USER_VIEW, phone)
    }
    let idView = this.$route.params.idView
    if (idView) {
      console.log(idView)
      this.mode = 'view'
      this.$store.dispatch(TYPES.DO_GET_ACCOUNT_RECORD, idView)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Recharge.vue